import type * as SchemaTypes from '../../../../apolloClient.types';

import type { SocPerformanceResultFragment } from '../Create/CreatePerformanceSocResult.api';
import { gql } from '@apollo/client';
import { SocPerformanceResultFragmentDoc } from '../Create/CreatePerformanceSocResult.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSocPerformanceResultMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateSocResultInput;
}>;


export type UpdateSocPerformanceResultMutation = (
  { __typename: 'Mutation' }
  & { updateSocResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateSocResultSuccessfulResponse' }
    & { result: (
      { __typename: 'PerformanceResult' }
      & SocPerformanceResultFragment
    ) }
  ) }
);


export const UpdateSocPerformanceResultDocument = /*#__PURE__*/ gql`
    mutation UpdateSocPerformanceResult($id: ObjectID!, $input: UpdateSocResultInput!) {
  updateSocResult(id: $id, input: $input) {
    ... on UpdateSocResultSuccessfulResponse {
      result {
        ...SocPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SocPerformanceResultFragmentDoc}`;
export type UpdateSocPerformanceResultMutationFn = Apollo.MutationFunction<UpdateSocPerformanceResultMutation, UpdateSocPerformanceResultMutationVariables>;

/**
 * __useUpdateSocPerformanceResultMutation__
 *
 * To run a mutation, you first call `useUpdateSocPerformanceResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocPerformanceResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocPerformanceResultMutation, { data, loading, error }] = useUpdateSocPerformanceResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocPerformanceResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocPerformanceResultMutation, UpdateSocPerformanceResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocPerformanceResultMutation, UpdateSocPerformanceResultMutationVariables>(UpdateSocPerformanceResultDocument, options);
      }
export type UpdateSocPerformanceResultMutationHookResult = ReturnType<typeof useUpdateSocPerformanceResultMutation>;
export type UpdateSocPerformanceResultMutationResult = Apollo.MutationResult<UpdateSocPerformanceResultMutation>;
export type UpdateSocPerformanceResultMutationOptions = Apollo.BaseMutationOptions<UpdateSocPerformanceResultMutation, UpdateSocPerformanceResultMutationVariables>;